import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { Outlet } from 'react-router-dom';
import { gameIdAtom } from '@/atoms/game/game';
import { gameTitleAtom } from '@/atoms/queries/game';
import { ContentState } from '@/components/contentState/ContentState';
import { EntityTopBar } from '@/components/topBar/EntityTopBar';
import { layoutScopeAtoms } from '@/consts/scope';
import { useResetFiltersOnAreaEntry } from '@/hooks/useResetFiltersOnAreaEntry';
import { useSetIdAtom } from '@/hooks/useSetIdAtom';
import { StatusTranslationKey } from '@/types/status';
import { AppShellContents } from '../AppShell';
import { SectionWrapper } from '../SectionWrapper';

const GameLayoutInner = () => (
  <SectionWrapper section="game">
    <Outlet />
  </SectionWrapper>
);

const GameLayoutWithData = () => {
  useSetIdAtom(gameIdAtom, 'gameId');
  const gameId = useAtomValue(gameIdAtom);

  return (
    <AppShellContents topBar={<EntityTopBar selectedEntityNameAtom={gameTitleAtom} />}>
      {gameId ? <GameLayoutInner /> : <ContentState status={StatusTranslationKey.LOADING} />}
    </AppShellContents>
  );
};

export const GameLayout = () => {
  useResetFiltersOnAreaEntry();
  return (
    <ScopeProvider atoms={layoutScopeAtoms}>
      <GameLayoutWithData />
    </ScopeProvider>
  );
};
